export default __webpack_public_path__ + "static/media/NextJS.625b9bd8.png";